import React from 'react';
import {BrowserRouter, Route} from 'react-router-dom';
import {PrivateRoute, PrivateRoutePartner} from "./PrivateRoute";
import {isBrowser} from "react-device-detect";
import {resolucion_tablet} from "./tools/resolucion";

import { ThemeProvider } from '@material-ui/core';
import {theme, themePartners} from "./theme";

import LoginPage from "./CropSense/components/LoginPage";
import LoginInitCreate from "./CropSense/components/LoginInitCreate";

import MobileLoginPage from "./CropSenseMobile/components/MobileLoginPage";
import MobileLoginInitCreate from "./CropSenseMobile/components/MobileLoginInitCreate";

import LoginPartners from "./Partners/components/LoginPage"

import CropSenseApp from "./CropSenseApp";
import PartnersApp from "./PartnersApp";


const Home = () => {
    return(
        <BrowserRouter>
            <ThemeProvider theme={theme}>
                <BrowserRouter basename={'app'}>
                    <PrivateRoute exact path='/' component={CropSenseApp}/>
                    <Route
                        path='/login'
                        component={isBrowser && !resolucion_tablet()? LoginPage : MobileLoginPage}
                    />
                </BrowserRouter>
            </ThemeProvider>

            <ThemeProvider theme={theme}>
                <BrowserRouter basename={'register'}>
                    <Route
                        exact path='/'
                        component={isBrowser && !resolucion_tablet()? LoginInitCreate : MobileLoginInitCreate}
                    />
                </BrowserRouter>
            </ThemeProvider>

            <ThemeProvider theme={themePartners}>
                <BrowserRouter basename={'partners'}>
                    <PrivateRoutePartner exact path='/' component={PartnersApp}/>
                    <Route
                        path='/login'
                        component={isBrowser && !resolucion_tablet()? LoginPartners : LoginPartners}
                    />
                </BrowserRouter>
            </ThemeProvider>
        </BrowserRouter>
    )
};

export default Home;
